import React from 'react'
import './style.css'

const OurServicesCard = ({ text, description, icon, techStackIcons }) => {
    return (
        <>
            <div className="our-services-card-box">
                <div className="our-services-icon">
                    <img src={icon ? icon : "/images/companies.svg"} alt="" />
                </div>

                <div className="service-card-arrow-box">
                    <i className="fa-solid fa-arrow-right-long"></i>
                </div>

                <div className="our-services-text">
                    <h3 className="services-heading-text">{text}</h3>
                    <p className="description-text" dangerouslySetInnerHTML={{
                        __html: description,
                    }}></p>
                    {techStackIcons && <div>
                        <h5 className='service-card-tech-stack-heading'>Tech Stacks:</h5>
                        <div className="services-tech-stack-icons">
                            {techStackIcons?.map((icon, index) => {
                                return <img src={icon.icon} width={icon.width} key={index} />
                            })}
                        </div>
                    </div>}
                </div>
            </div>
        </>
    )
}

export default OurServicesCard